import { Capacitor } from '@capacitor/core';

/**
 * Version App Store (iOS) : les paiements/dons (Stripe, PayPal…) doivent être
 * masqués (règle Apple 3.1.1). Détection :
 * 1. App Capacitor iOS (enveloppe native)
 * 2. Paramètre d'URL ?platform=ios (persisté) — utile pour tester ou pour une
 *    autre enveloppe iOS (?platform=android pour annuler).
 */
export const isIosApp = () => {
  try {
    if (Capacitor.getPlatform() === 'ios') return true;
  } catch { /* noop */ }
  try {
    const qp = new URLSearchParams(window.location.search);
    const p = qp.get('platform');
    if (p === 'ios') { localStorage.setItem('hypnose_platform', 'ios'); return true; }
    if (p === 'android' || p === 'web') { localStorage.removeItem('hypnose_platform'); return false; }
    return localStorage.getItem('hypnose_platform') === 'ios';
  } catch { return false; }
};
